import { createTheme } from '@mui/material';

import palette from './palette';
import typography from './typography';
import overrides from './overrides';

const theme = createTheme({
  palette,
  typography,
  components: overrides,
  zIndex: {
    appBar: 1200,
    drawer: 1100,
  },
  topLogo: '/app/images/eventos/logo.png',
  topLogoWidth: '170px',
  topIcon: '/app/images/eventos/favicon_16.ico',
  appBarColor: 'primary',
  documentTitle: 'Eventos42',
  registrationAvailable: true,
  chatIcon: true,
});

export default theme;
